/* eslint-disable no-unused-vars */

import React from "react";
import {
  ANDREANI,
  HOP,
  OCA,
  OCASA,
  PICKIT,
  RAPIBOY,
  SOUTHPOST,
  URBANO,
} from "../../utils/constants";
import OcaCredentials from "../../components/configuration/credentials/OcaCredentials";
import RapiboyCredentials from "../../components/configuration/credentials/RapiboyCredentials";
import OcasaCredentials from "../../components/configuration/credentials/OcasaCredentials";
import HopCredentials from "../../components/configuration/credentials/HopCredentials";
import SouthpostCredentials from "../../components/configuration/credentials/SouthpostCredentials";
import UrbanoCredentials from "../../components/configuration/credentials/UrbanoCredentials";
import AndreaniCredentials from "../../components/configuration/credentials/AndreaniCredentials";
import PickitCredentials from "../../components/configuration/credentials/PickitCredentials";
import { ICredentialsStep } from "../../interfaces/configuration";

type CredentialComponent = React.ComponentType<ICredentialsStep>;

interface ICarrierCredentialsStrategy {
  getCredentialComponent(
    carrierName: string,
    configuration: ICredentialsStep
  ): React.ReactElement;
}

export default new class CarrierCredentialsStrategy implements ICarrierCredentialsStrategy
{
  private registry: Record<string, CredentialComponent>;
  constructor() {
    this.registry = {
      [OCA]: OcaCredentials,
      [RAPIBOY]: RapiboyCredentials,
      [OCASA]: OcasaCredentials,
      [HOP]: HopCredentials,
      [SOUTHPOST]: SouthpostCredentials,
      [URBANO]: UrbanoCredentials,
      [ANDREANI]: AndreaniCredentials,
      [PICKIT]: PickitCredentials,
    };
  }
  getCredentialComponent(
    carrierName: string,
    configuration: ICredentialsStep
  ): React.ReactElement {
    const Component = this.registry[carrierName];
    if (!Component) {
      return <></>;
    }

    return <Component {...configuration} />;
  }
};
